"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlTreeElement = void 0;
var utils_1 = require("./utils");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var actionTreeElement_1 = require("./actionTreeElement");
var typestyle_1 = require("typestyle");
var buttons_1 = require("../buttons");
var tableRowElement_1 = require("./tableRowElement");
var tableRowElementCheckbox_1 = require("./tableRowElementCheckbox");
var generic_1 = require("../generic");
var ControlTreeElement = (function (_super) {
    __extends(ControlTreeElement, _super);
    function ControlTreeElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlTreeElement.prototype.render = function () {
        var _this = this;
        var control_element = this.props.control;
        var control = control_element.control;
        var key = "".concat(this.props.parent_id, "_").concat(control.id);
        var htmlID = (0, utils_1.getControlId)(control_element);
        var childCount = 0;
        var actions = control_element.actions
            .filter(function (action_element) {
            if (!_this.props.filterElements) {
                return true;
            }
            return !(_this.props.isActionFilteredOut && _this.props.isActionFilteredOut(action_element));
        })
            .map(function (action_element) {
            childCount++;
            return (React.createElement(actionTreeElement_1.ActionTreeElement, { parent_id: htmlID, action: action_element, key: key, showCheckbox: _this.props.showCheckbox, inputChangeHandler: _this.props.inputChangeHandler, isChecked: _this.props.isChecked, onClick: _this.props.onClickAction, addAddActionPlaceholder: !!_this.props.onAddActionClicked }));
        });
        if (this.props.filterElements && !control.is_assigned_to && childCount == 0)
            return null;
        var label_props = {
            project_title: control.project_title,
            number: "".concat(get_term('Control'), " #").concat(control.control_number),
            title: control.description,
            owner: control.assigned_to,
            status_display: control.status_display,
            deadline: control.deadline,
            elementType: tableRowElement_1.ElementTypes.control,
        };
        var baseClass = "TreeElement";
        var colorClass = (control.is_assigned_to === false ||
            this.props.filterElements && this.props.overWritingFilter ?
            "table-info" :
            "table-primary");
        var hoverClass = baseClass + (this.props.onClick ? "--hoverable" : "--not-hoverable");
        var classNames = (0, typestyle_1.classes)(baseClass, hoverClass, "TreeElement--NoBorder");
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", { className: classNames, onClick: function (e) {
                    _this.props.onClick && _this.props.onClick(control_element);
                } },
                React.createElement(tableRowElementCheckbox_1.TableRowElementCheckbox, { id: htmlID, name: "controls", value: control.id.toString(), showCheckbox: this.props.showCheckbox, disabled: control.is_assigned_to === false || this.props.overWritingFilter, label_props: label_props, inputChangeHandler: this.props.inputChangeHandler, isChecked: this.props.isChecked, colorClass: colorClass }),
                this.props.addNodeIcon && (React.createElement("td", { className: colorClass },
                    React.createElement(buttons_1.ActionButton, { className: "btn btn-link add_control p-0", title: gettext("Quick add an action"), onClick: function (e) {
                            e.stopPropagation();
                            _this.props.onAddActionClicked && _this.props.onAddActionClicked(control_element);
                        } },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }))))),
            actions));
    };
    ControlTreeElement = __decorate([
        mobx_react_1.observer
    ], ControlTreeElement);
    return ControlTreeElement;
}(React.Component));
exports.ControlTreeElement = ControlTreeElement;
